export default __webpack_public_path__ + "static/media/checkmark.999db11b.svg";